<template>
  <div>
    <div class="newsType newsType0" v-if="newsType == '交易记录'">
      <div class="newTypeLabel">{{$t('news.newsType.交易记录')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType1" v-if="newsType == '同行信息'">
      <div class="newTypeLabel">{{$t('news.newsType.同行信息')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType2" v-if="newsType == '业主动态'">
      <div class="newTypeLabel">{{$t('news.newsType.业主动态')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType3" v-if="newsType == '租户动态'">
      <div class="newTypeLabel">{{$t('news.newsType.租户动态')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType4" v-if="newsType == '宏观动态'">
      <div class="newTypeLabel">{{$t('news.newsType.宏观动态')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType5" v-if="newsType == '人员变动'">
      <div class="newTypeLabel">{{$t('news.newsType.人员变动')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType6" v-if="newsType == '市场洞察'">
      <div class="newTypeLabel">{{$t('news.newsType.市场洞察')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
    <div class="newsType newsType7" v-if="newsType == '住宅'">
      <div class="newTypeLabel">{{$t('news.newsType.住宅')}}</div>
      <i class="newTypeLabelArrow"></i>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'newsTypeLabel',
    props:{
      newsType:{
        type:String,
        default:'交易记录',
      }
    },
    data(){
      return{

      }
    }
  }
</script>

<style scoped lang="less">
  .newsType{
    position: relative;
    border-radius:0 5px 5px 0;
    .newTypeLabel{
      font-size: 10px;
      line-height: 20px;
      padding: 0 7px 0 5px;
    }
    .newTypeLabelArrow{
      position: absolute;
      border:10px solid rgba(0,0,0,0);
      height:0;
      line-height:0;
      font-size:0;
      top:0px;
      left:-20px;
    }
  }
  .newsType0{ //交易记录
    background: #FFF3DF;
    .newTypeLabel{
      color: #FA9B00;
    }
    .newTypeLabelArrow{
      border-right-color:#FFF3DF;
    }
  }
  .newsType1{ //同行信息
    background: #FFE4E5;
    .newTypeLabel{
      color: #EE4248;
    }
    .newTypeLabelArrow{
      border-right-color:#FFE4E5;
    }
  }
  .newsType2{ //业主动态
    background: #ECECEC;;
    .newTypeLabel{
      color: #333333;
    }
    .newTypeLabelArrow{
      border-right-color:#ECECEC;;
    }
  }
  .newsType3{ //租户动态
    background: #EAF6FF;
    .newTypeLabel{
      color: #0481E1;
    }
    .newTypeLabelArrow{
      border-right-color:#EAF6FF;
    }
  }
  .newsType4{ //宏观动态
    background: #CCF9F0;
    .newTypeLabel{
      color: #0DC09B;;
    }
    .newTypeLabelArrow{
      border-right-color:#CCF9F0;
    }
  }
  .newsType5{ //人员变动
    background: #F4E2FF;
    .newTypeLabel{
      color: #9325D9;
    }
    .newTypeLabelArrow{
      border-right-color:#F4E2FF;
    }
  }

  .newsType6{ //人员变动
    background: #E4FBFF;
    .newTypeLabel{
      color: #00AFCD;
    }
    .newTypeLabelArrow{
      border-right-color:#E4FBFF;
    }
  }

  .newsType7{ //住宅
    background: #FFE8D5;
    min-width: 50px;
    text-align: center;
    .newTypeLabel{
      color: #E78432;
    }
    .newTypeLabelArrow{
      border-right-color:#FFE8D5;
    }
  }
</style>